import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Button from '../Global/Buttons/Button';
import SessionNav from './SessionNav';
import VerticalTextLockup from '../Global/Typography/VerticalTextLockup';
import NoResultsMessage from '../Global/Messages/NoResultsMessage';

const SessionOverview = ({ drills, activeDrill, changeDrill, loading }) => {
  const swapDrill = (e, index) => {
    e.preventDefault();
    changeDrill(index);
  };

  let sessionList;
  if (drills.length > 0) {
    sessionList = (
      <ol className="faux-list">
        {drills.map((drill, index) => {
          let readableIndex = index;
          readableIndex += 1;

          const activeClass = classNames({ active: activeDrill === index });

          return (
            <li key={drill.id} className={activeClass}>
              <Button onClick={e => swapDrill(e, index)} classes="minimal-content-teaser" faux>
                <span className="teaser-index fw-medium">{readableIndex}</span>
                {drill.image.data.src &&
                  <img alt="" src={drill.image.data.src} />
                }
                <div className="minimal-content-text">
                  <VerticalTextLockup
                    title={<h3 className="like-p">{drill.title}</h3>}
                    subtitle={<p className="like-small">{drill.summary}</p>}
                  />
                </div>
              </Button>
            </li>
          );
        })}
      </ol>
    );
  } else {
    sessionList = (
      <NoResultsMessage
        title="Oops! No practices have been added to this session."
        text="Why not view some Coaching Manual approved sessions instead?"
        cta={<a href="/sessions" className="btn">View all Sessions</a>}
        loading={loading}
      />
    );
  }

  let activeNumber = activeDrill;
  activeNumber += 1;
  let sessionCount;
  if (drills.length > 0) {
    sessionCount = ` - ${activeNumber} / ${drills.length}`;
  }

  return (
    <div className="session-overview-container">
      <div className="session-overview">
        <h2 className="session-overview-title h2 fw-medium">Session overview {sessionCount}</h2>
        <div className="session-overview-list">
          {sessionList}
        </div>
        {drills.length > 1 &&
          <SessionNav changeDrill={changeDrill} />
        }
      </div>
    </div>
  );
};

SessionOverview.propTypes = {
  drills: PropTypes.array,
  activeDrill: PropTypes.number,
  changeDrill: PropTypes.func,
  loading: PropTypes.bool,
};

export default SessionOverview;



// WEBPACK FOOTER //
// ./library/app/components/Session/SessionOverview.js